var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../assets/about-banner.png")}}),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticStyle:{"width":"1280px"},attrs:{"span":24}},[_c('el-row',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../assets/about-content-0.png")}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }